/*** IMPORTS FROM imports-loader ***/


/**
 * GIS Server APIs
 * A powerful suite of mapping, geospatial and location-based APIs for your applications and services.
 *
 * OpenAPI spec version: v1.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.3.1
 *
 * Do not edit the class manually.
 *
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/PersistedGrantsResponse', 'model/ResponseObject'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/PersistedGrantsResponse'), require('../model/ResponseObject'));
  } else {
    // Browser globals (root is window)
    if (!root.GisServerApis) {
      root.GisServerApis = {};
    }
    root.GisServerApis.AuthApi = factory(root.GisServerApis.ApiClient, root.GisServerApis.PersistedGrantsResponse, root.GisServerApis.ResponseObject);
  }
}(this, function(ApiClient, PersistedGrantsResponse, ResponseObject) {
  'use strict';

  /**
   * Auth service.
   * @module api/AuthApi
   * @version 1.0.0
   */

  /**
   * Constructs a new AuthApi. 
   * @alias module:api/AuthApi
   * @class
   * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the deleteAccountByAccountIdTokenV1 operation.
     * @callback module:api/AuthApi~deleteAccountByAccountIdTokenV1Callback
     * @param {String} error Error message, if any.
     * @param {module:model/ResponseObject} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Delete tokens from an account.
     * @param {String} accountId The ID of the account that the tokens delete from.
     * @param {Object} opts Optional parameters
     * @param {Array.<String>} opts.keys A collection of the persisted grant key to be deleted.
     * @param {module:api/AuthApi~deleteAccountByAccountIdTokenV1Callback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ResponseObject}
     */
    this.deleteAccountByAccountIdTokenV1 = function(accountId, opts, callback) {
      opts = opts || {};
      var postBody = null;

      // verify the required parameter 'accountId' is set
      if (accountId === undefined || accountId === null) {
        throw new Error("Missing the required parameter 'accountId' when calling deleteAccountByAccountIdTokenV1");
      }


      var pathParams = {
        'accountId': accountId
      };
      var queryParams = {
      };
      var collectionQueryParams = {
        'keys': {
          value: opts['keys'],
          collectionFormat: 'multi'
        },
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['API Key', 'Client Credentials', 'Resource Owner Password'];
      var contentTypes = [];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = ResponseObject;

      return this.apiClient.callApi(
        '/api/v1/accounts/{accountId}/tokens', 'DELETE',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the deleteTokenV1 operation.
     * @callback module:api/AuthApi~deleteTokenV1Callback
     * @param {String} error Error message, if any.
     * @param {module:model/ResponseObject} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Delete tokens.
     * @param {Object} opts Optional parameters
     * @param {Array.<String>} opts.keys A collection of the persisted grant key to be deleted.
     * @param {module:api/AuthApi~deleteTokenV1Callback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ResponseObject}
     */
    this.deleteTokenV1 = function(opts, callback) {
      opts = opts || {};
      var postBody = null;


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
        'keys': {
          value: opts['keys'],
          collectionFormat: 'multi'
        },
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['API Key', 'Client Credentials', 'Resource Owner Password'];
      var contentTypes = [];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = ResponseObject;

      return this.apiClient.callApi(
        '/api/v1/tokens', 'DELETE',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the getAccountByAccountIdTokenV1 operation.
     * @callback module:api/AuthApi~getAccountByAccountIdTokenV1Callback
     * @param {String} error Error message, if any.
     * @param {module:model/PersistedGrantsResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get tokens.
     * @param {String} accountId The ID of the owner.
     * @param {Object} opts Optional parameters
     * @param {Number} opts.offset The start index of the records that should return.
     * @param {Number} opts.length The length of the returnning records.
     * @param {module:api/AuthApi~getAccountByAccountIdTokenV1Callback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/PersistedGrantsResponse}
     */
    this.getAccountByAccountIdTokenV1 = function(accountId, opts, callback) {
      opts = opts || {};
      var postBody = null;

      // verify the required parameter 'accountId' is set
      if (accountId === undefined || accountId === null) {
        throw new Error("Missing the required parameter 'accountId' when calling getAccountByAccountIdTokenV1");
      }


      var pathParams = {
        'accountId': accountId
      };
      var queryParams = {
        'offset': opts['offset'],
        'length': opts['length'],
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['API Key', 'Client Credentials', 'Resource Owner Password'];
      var contentTypes = [];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = PersistedGrantsResponse;

      return this.apiClient.callApi(
        '/api/v1/accounts/{accountId}/tokens', 'GET',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the getTokenV1 operation.
     * @callback module:api/AuthApi~getTokenV1Callback
     * @param {String} error Error message, if any.
     * @param {module:model/PersistedGrantsResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get tokens.
     * @param {Object} opts Optional parameters
     * @param {Number} opts.offset The start index of the records that should return.
     * @param {Number} opts.length The length of the returnning records.
     * @param {module:api/AuthApi~getTokenV1Callback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/PersistedGrantsResponse}
     */
    this.getTokenV1 = function(opts, callback) {
      opts = opts || {};
      var postBody = null;


      var pathParams = {
      };
      var queryParams = {
        'offset': opts['offset'],
        'length': opts['length'],
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['API Key', 'Client Credentials', 'Resource Owner Password'];
      var contentTypes = [];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = PersistedGrantsResponse;

      return this.apiClient.callApi(
        '/api/v1/tokens', 'GET',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));

